import { accountGetInfo, canUseOnReady } from 'root/common/nativeApi/index';
import env from 'root/common/util/env';

/**
 * 初始化真游客模式
 * 用户等级小于等于1
 **/
export async function initVisitor() {
    if (!env.isApp) return; // 仅原生支持游客模式
    const isSupport = await canUseOnReady('jumpLogin');
    if (!isSupport) return; // 不支持jumpLogin(登录)插件，代表不支持游客模式
    const res = await accountGetInfo();
    const data = (res && res.data) || null;
    if (!data) return;
    // 已登录的老用户，直接退出，否则会因为userLevel字段存在默认值（1）出现异常
    if (data.channelId === undefined && data.userId) return;
    const userLevel = data.userLevel || 99;
    console.log('userLevel:', userLevel);
    if (userLevel <= 1) {
        sessionStorage.setItem('is_visitor', 1);
    } else {
        sessionStorage.removeItem('is_visitor');
    }
}

// 判定是否游客模式
export function isVisitor() {
    return sessionStorage.getItem('is_visitor') == '1';
}
